import React from 'react';
import { Link } from 'react-router-dom';
import { IoLocationSharp, IoCall } from "react-icons/io5";
import { MdAlternateEmail } from "react-icons/md";
import { FiHeart } from "react-icons/fi";
import { LuFacebook, LuInstagram, LuLinkedin, LuYoutube } from "react-icons/lu";

import esightLogo from '../../assets/images/esight-logo-white.png';

const Footer = () => {
    return (
        <footer>
            <div className="container">
                <div className="footerContact">
                    <div className="footerContactCol1">
                        <h2 className='title'>Nursing Educator and Exam Preparation Specialist</h2>
                        <p>Nursing educator specializing in exam preparation for international certifications like Prometric, DHA, NCLEX RN, and more.</p>
                        <div className="footerSocialLinks">
                            <Link to="https://www.facebook.com/athenacoachinginternational" target="_blank" rel="noreferrer">
                                <LuFacebook />
                            </Link>
                            <Link to="https://www.instagram.com/athenacoachingcentre/" target="_blank" rel="noreferrer">
                                <LuInstagram />
                            </Link>
                            <Link to="https://www.linkedin.com/company/athena-coaching-centre" target="_blank" rel="noreferrer">
                                <LuLinkedin />
                            </Link>
                            <Link to="https://m.youtube.com/channel/UCDmMxK9qV7BL6i1I4As78yw" target="_blank" rel="noreferrer">
                                <LuYoutube />
                            </Link>
                        </div>
                        <ul>
                            <li>
                                <div className="icon">
                                    <IoLocationSharp />
                                </div>
                                <div className="details">
                                    <h3>Address</h3>
                                    <h4>Joson Arcade, Opp. Chungath Jewellers <br />Aluva Road, Angamaly Pin: 683572</h4>
                                </div>
                            </li>
                            <li>
                                <div className="icon">
                                    <IoCall />
                                </div>
                                <div className="details">
                                    <h3>Phone</h3>
                                    <a href="tel:+917736360007">+91 7736360007</a>
                                    <a href="tel:+914842459007">+91 4842459007</a>
                                </div>
                            </li>
                            <li>
                                <div className="icon">
                                    <MdAlternateEmail />
                                </div>
                                <div className="details">
                                    <h3>Email</h3>
                                    <a href="mailto:athenacoachingcentre@gmail.com">athenacoachingcentre@gmail.com</a>
                                    <a href="mailto:info@athenacoachingcentre.com">info@athenacoachingcentre.com</a>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className="footerStrip">
                <div className="container">
                    <div className="footerStripMain">
                        <div className="footerMainCol1">
                            <p>Copyright © 2025 Athena Coaching Centre. All Rights Reserved.</p>
                        </div>
                        <div className="footerMainCol2">
                            <p>Designed with</p>
                            <FiHeart />
                            <a href="https://esightsolutions.com/" target="_blank">
                                <img src={esightLogo} alt="" />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;